import React, { ReactText, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import translate from '../translate';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import {
    LoadLocationsForMansionId,
    MansionById,
} from '../../store/locationsSlice';
import TitleCard from '../main/title-card';
import { LoadMansions, Mansion } from '../../store/mansionsSlice';
import VipAddUserCard from '../vip/vip-add-user-card';
import VipRemoveUserCard from '../vip/vip-remove-user-card';
import VipLaundryRoomInfoCard from '../vip/vip-laundry-room-info-card';
import { resetAddVipUsers } from '../../store/vipUsersSlice';
import { Link } from 'react-router';
import LocationPricingCard from './prices/location-pricing-card';
import withParams from '../../nav/withParams';

interface Props {
    locationsByMansionsById: MansionById;
    mansionsById: { [key: string]: Mansion };
    LoadLocationsForMansionId: any;
    LoadMansions: any;
    params: {
        location_id: ReactText;
        object_id: ReactText;
    };
    strings: {
        title: string;
        cancel: string;
    };

    ResetAddVipUsers: () => void;
}

function VipUserPricing(props: Props) {
    useEffect(() => {
        props.LoadLocationsForMansionId(Number(props.params.object_id));
        props.LoadMansions();
        props.ResetAddVipUsers();
    }, []);

    const mansionId = Number(props.params.object_id);
    const locationId = Number(props.params.location_id);
    const locationsByMansions = props.locationsByMansionsById[mansionId] || {};
    const object = props.mansionsById[mansionId];
    const location = locationsByMansions[locationId];

    if (!object || !location) {
        return <div> Loading </div>;
    }

    return (
        <Row>
            <LeftSide addClass="">
                <TitleCard
                    title={props.strings.title}
                    left={{
                        content: (
                            <Link
                                to={`/objects/${mansionId}/${locationId}`}
                                className="icon icon-wew-arrow-left icon-sm"
                            />
                        ),
                        title: props.strings.cancel,
                    }}
                />
            </LeftSide>
            <Col xs={6}>
                <LocationPricingCard
                    locationId={location.id}
                    hideLinkToDiscount
                />
                <VipAddUserCard laundryRoomId={location.id} />
                <VipRemoveUserCard laundryRoomId={location.id} />
            </Col>
            <RightSide>
                <VipLaundryRoomInfoCard />
            </RightSide>
        </Row>
    );
}

export default connect(
    (store: RootState) => ({
        mansionsById: store.mansions.mansionsById,
        locationsByMansionsById: store.locations.locationsByMansionsById,
    }),
    {
        LoadLocationsForMansionId,
        LoadMansions,
        ResetAddVipUsers: resetAddVipUsers,
    }
)(translate('VipUserPricing')(withParams(VipUserPricing)));
